import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { setVizLoading } from '../../../../store/visualizerSlice';
import ProductGroupStep from '../ProductGroupStep/ProductGroupStep';
import StepNavigation from '../../StepNavigation/StepNavigation';
import styles from './Paint.module.css';

const TABS = ['Wall', 'Trim'];

// Match surface names that represent walls vs trim. Case-insensitive substring.
const WALL_KEYWORDS = ['painted walls'];
const TRIM_KEYWORDS = ['trim', 'baseboard', 'crown', 'door'];

function applyPaint(productId, kind, dispatch) {
    const chamViz = document.getElementById('chamViz');
    if (!chamViz || !productId) return;
    dispatch(setVizLoading(true));

    const kw = kind === 'Trim' ? TRIM_KEYWORDS : WALL_KEYWORDS;

    chamViz.applyByFilter(
        productId,
        '',
        function (newSel) {
            const n = String(this.name || '').toLowerCase();
            if (kw.some(k => n.includes(k))) return newSel;
            return this.sel;
        },
        true
    );
}

export default function Paint({
    stepIndex,
    room = '',
    onViewAllApplied,
    onNext,
    onPrevious
}) {
    const dispatch = useDispatch();
    const [activeTab, setActiveTab] = useState('Wall');

    const handleWallSelect = useCallback((product) => {
        applyPaint(product.id, 'Wall', dispatch);
    }, [dispatch]);

    const handleTrimSelect = useCallback((product) => {
        applyPaint(product.id, 'Trim', dispatch);
    }, [dispatch]);

    return (
        <div className={styles.wrapper}>
            <StepNavigation
                title="Paint"
                onNext={onNext}
                onPrevious={onPrevious}
                onViewAllApplied={onViewAllApplied}
            />

            <div className={styles.tabs}>
                {TABS.map(tab => (
                    <button
                        key={tab}
                        type="button"
                        className={`${styles.tab} ${activeTab === tab ? styles.tabActive : ''}`}
                        onClick={() => setActiveTab(tab)}
                    >
                        {tab}
                    </button>
                ))}
            </div>

            <div className={styles.tabContent}>
                {activeTab === 'Wall' && (
                    <div className={styles.productArea}>
                        <ProductGroupStep
                            title=""
                            stepName="Paint_Wall"
                            seriesId="9789"
                            surfaceName="Painted Walls"
                            stepIndex={stepIndex}
                            room={room}
                            onViewAllApplied={onViewAllApplied}
                            onNext={onNext}
                            onPrevious={onPrevious}
                            hideNav
                            onProductSelect={handleWallSelect}
                        />
                    </div>
                )}

                {activeTab === 'Trim' && (
                    <div className={styles.productArea}>
                        <ProductGroupStep
                            title=""
                            stepName="Paint_Trim"
                            seriesId="9789"
                            surfaceName="Trim"
                            stepIndex={stepIndex}
                            room={room}
                            onViewAllApplied={onViewAllApplied}
                            onNext={onNext}
                            onPrevious={onPrevious}
                            hideNav
                            onProductSelect={handleTrimSelect}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}

Paint.propTypes = {
    stepIndex: PropTypes.number.isRequired,
    room: PropTypes.string,
    onViewAllApplied: PropTypes.func,
    onNext: PropTypes.func,
    onPrevious: PropTypes.func
};
